import { render, staticRenderFns } from "./KioskSignaturePad.vue?vue&type=template&id=a64d5c66&scoped=true"
import script from "./KioskSignaturePad.vue?vue&type=script&lang=js"
export * from "./KioskSignaturePad.vue?vue&type=script&lang=js"
import style0 from "./KioskSignaturePad.vue?vue&type=style&index=0&id=a64d5c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64d5c66",
  null
  
)

export default component.exports